const scrollSearchbar = ({
  classNamePrefix,
  offsetInput
}) => {
  const searchBar = document.querySelector("#search-bar");
  const clearBtn = document.querySelector(`.${classNamePrefix}__icon-cross`);

  searchBar.addEventListener("input", () => {
    clearBtn.style.display = searchBar.value.length > 0 ? 'block' : 'none';
  });

  clearBtn.addEventListener("click", () => {
    searchBar.value = "";
    clearBtn.style.display = "none";
  });

  const autocompleteList = document.querySelector(".inbenta-autocomplete");
  const observerAutocomplete = new MutationObserver(() => {
    toggleBackdrop();
  });

  observerAutocomplete.observe(autocompleteList, {
    subtree: true,
    childList: true,
    attributes: true,
  });

    let backdropTop = "";
  let backdropPosition = "";

  const toggleBackdrop = () => {
    const autocompleteDisplayValue = window.getComputedStyle(document.querySelector(".inbenta-autocomplete")).getPropertyValue("display");
    const autocompleteListLength = document.querySelectorAll(".autocomplete-list > li").length;
    const searchBarHeader = document.querySelector(`.${classNamePrefix}__header`);
    const backdrop = document.querySelector(`.${classNamePrefix}__backdrop`);

        if (autocompleteDisplayValue === "block" && autocompleteListLength > 0 && searchBarHeader && !backdrop) {
      document.documentElement.style.setProperty("--backdrop-height", `${backdropHeight()}px`);

      searchBarHeader.classList.add("backdrop-active");

      let newElement = document.createElement("div");
      newElement.classList.add(`${classNamePrefix}__backdrop`)
      newElement.setAttribute("aria-hidden", true)
      newElement.style.top = backdropTop;
      newElement.style.position = backdropPosition;
      searchBarHeader.after(newElement);

    } else if (autocompleteDisplayValue === "none" && searchBarHeader && backdrop) {
      backdrop.remove();
      searchBarHeader.classList.remove("backdrop-active");
    }
  }

  const backdropHeight = () => {
    const searchBarHeader = document.querySelector(`.${classNamePrefix}__header`);

    let rect = searchBarHeader.getBoundingClientRect();
    let bottomDiv = rect.bottom + window.scrollY;
    let pageHeight = document.documentElement.scrollHeight;

    return distance = pageHeight - bottomDiv;
  }

  let searchBarHeader = document.querySelector(`.${classNamePrefix}__header`);
  const searchBarHeaderPositionInit = searchBarHeader.getBoundingClientRect().top + window.scrollY;
  const mainTag = document.querySelector("main");
  const searchBarEl = document.querySelector(`.${classNamePrefix}`);
  const submitBtn = document.querySelector(`.${classNamePrefix}__btn.submit`);

  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const isMobile = window.matchMedia("(max-width: 1024px)").matches;
    if (!isMobile) return; 

        const isZoom = () => window.matchMedia("(min-width: 768px) and (max-width: 1425px)").matches;
    const backdrop = document.querySelector(`.${classNamePrefix}__backdrop`);

    if (window.scrollY - (offsetInput * (isZoom() ? 0.75 : 1)) >= searchBarHeaderPositionInit) {
      searchBarEl.classList.add("fixed");

      searchBarHeader = document.querySelector(`.${classNamePrefix}__header`);
      mainTag.style.marginTop = `${searchBarHeader.offsetHeight + 84}px`;

      backdropTop = `${searchBarHeader.offsetHeight + 24}px`;
      backdropPosition = "fixed";
    } else {
      searchBarEl.classList.remove("fixed");
      mainTag.style.marginTop = "";

      backdropTop = "";
      backdropPosition = "";
    }

    if (backdrop) {
      backdrop.style.top = backdropTop;
      backdrop.style.position = backdropPosition;
    }        

    const diffScroll = Math.abs(window.scrollY - lastScrollY);

    if (diffScroll >= 100) {
      const activeEl = document.activeElement;

      if ((activeEl.id === "search-bar") && (activeEl.tagName === "INPUT")) {
        activeEl.blur();
      }

      lastScrollY = window.scrollY;
    }
  }

  const resetStyles = () => {
    const backdrop = document.querySelector(`.${classNamePrefix}__backdrop`);

    searchBarEl.classList.remove("fixed");
    mainTag.style.marginTop = "";

    if (backdrop) {
      backdrop.style.top = "";
      backdrop.style.position = "";
    }
  }

  window.addEventListener("scroll", handleScroll);

  window.addEventListener("resize", () => {
    const isMobile = window.matchMedia("(max-width: 1023px)").matches;
    if (!isMobile) {
      resetStyles(); 
    } else {
      handleScroll(); 
    }
  });

  submitBtn.addEventListener("click", () => {
    const isMobile = window.matchMedia("(max-width: 1023px)").matches;
    if (!isMobile) return; 

    if (window.scrollY - offsetInput >= searchBarHeaderPositionInit) {
      window.scrollTo({
        top: searchBarHeaderPositionInit,
        behavior: "smooth"
      });
    }
  });
} 

(function scrollSearchbarHandler() {
  window.GlobalSite = window.GlobalSite || {};

  const exportToGlobalSite = GlobalSite.checkDependency('GlobalSite.exportToGlobalSite');

  exportToGlobalSite({
    scrollSearchbar,
  });
})();
